<template>
  <div class="row">
    <div class="col-md-12">
      <template v-if="media.sm">
        <el-descriptions :column="1" border direction="vertical">
          <template slot="title">
            <slot name="title"></slot>
          </template>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['far', 'id-card']"></font-awesome-icon>
              Rut
            </template>
            <span data-cy="affiliation-idcard">{{ idcard | rutFormat }}</span>
          </el-descriptions-item>
          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['far', 'id-badge']"></font-awesome-icon>
              Nombre solicitante
            </template>
            <span data-cy="affiliation-fullname">{{ fullname }}</span>
          </el-descriptions-item>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['fas', 'envelope']"></font-awesome-icon>
              Correo electrónico
            </template>
            <span data-cy="affiliation-email">{{ email }}</span>
          </el-descriptions-item>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['fas', 'location-arrow']"></font-awesome-icon>
              Domicilio electoral
            </template>
            <span data-cy="affiliation-address">{{ address }}</span>
          </el-descriptions-item>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['fas', 'phone']"></font-awesome-icon>
              Teléfono fijo
            </template>
            <span data-cy="affiliation-phone">{{ phone }}</span>
          </el-descriptions-item>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['fas', 'check']"></font-awesome-icon>
              Tipo de Problema
            </template>
            <span data-cy="reclaim-type-problem">{{ typeProblem }}</span>
          </el-descriptions-item>
          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['fas', 'paragraph']"></font-awesome-icon>
              Detalle del reclamo
            </template>
            <span data-cy="reclaim-detail">{{ detail }}</span>
          </el-descriptions-item>

          <el-descriptions-item content-class-name="pp-el-descriptions-item"
                                v-if="state !== null">
            <template slot="label">
              <span class="el-icon-bell"></span>
              Estado de revisión
            </template>
            <el-tag :type="estadoTag(stateCode)" data-cy="affiliation-state">{{ state }}</el-tag>
          </el-descriptions-item>

        </el-descriptions>
      </template>
      <template v-else>
        <el-descriptions :column="4" border>
          <template slot="title">
            <slot name="title"></slot>
          </template>

          <el-descriptions-item span="1" content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['far', 'id-card']"></font-awesome-icon>
              Rut
            </template>
            <span data-cy="affiliation-idcard">{{ idcard | rutFormat }}</span>
          </el-descriptions-item>
          <el-descriptions-item span="3" content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['far', 'id-badge']"></font-awesome-icon>
              Nombre solicitante
            </template>
            <span data-cy="affiliation-fullname">{{ fullname }}</span>
          </el-descriptions-item>

          <el-descriptions-item span="2" content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['fas', 'envelope']"></font-awesome-icon>
              Correo electrónico
            </template>
            <span data-cy="affiliation-email">{{ email }}</span>
          </el-descriptions-item>

          <el-descriptions-item span="2" content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['fas', 'phone']"></font-awesome-icon>
              Teléfono fijo
            </template>
            <span data-cy="affiliation-phone">{{ phone }}</span>
          </el-descriptions-item>

          <el-descriptions-item span="4" content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['fas', 'location-arrow']"></font-awesome-icon>
              Domicilio electoral
            </template>
            <span data-cy="affiliation-address">{{ address }}</span>
          </el-descriptions-item>

          <el-descriptions-item span="4" content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['fas', 'check']"></font-awesome-icon>
              Tipo de Problema
            </template>
            <span data-cy="reclaim-type-problem">{{ typeProblem }}</span>
          </el-descriptions-item>
          <el-descriptions-item span="4" content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['fas', 'paragraph']"></font-awesome-icon>
              Detalle del reclamo
            </template>
            <span data-cy="reclaim-detail">{{ detail }}</span>
          </el-descriptions-item>

          <el-descriptions-item span="4" content-class-name="pp-el-descriptions-item"
                                v-if="state !== null">
            <template slot="label">
              <span class="el-icon-bell"></span>
              Estado de revisión
            </template>
            <el-tag :type="estadoTag(stateCode)" data-cy="affiliation-state">{{ state }}</el-tag>
          </el-descriptions-item>

        </el-descriptions>
      </template>

    </div>
  </div>
</template>

<script>

import {Descriptions, DescriptionsItem, Tag} from "element-ui";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {ActividadCiudadanoEstadoMixin} from "@/mixins/actividadCiudadanoEstado";

export default {
  name: "ReclaimDetail",
  components: {
    [Descriptions.name]: Descriptions,
    [DescriptionsItem.name]: DescriptionsItem,
    [Tag.name]: Tag,
  },
  props: {
    idcard: {
      type: String,
      required: true
    },
    fullname: {
      type: String,
      required: true
    },
    address: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    },
    phone: {
      type: String,
      required: true
    },
    state: {
      type: String,
      required: false,
      default: null
    },
    typeProblem: {
      type: String,
      required: true
    },
    detail: {
      type: String,
      required: true
    },
    stateCode: {
      type: Number,
      required: false,
      default: 0
    }
  },
  mixins: [
    ScreenSizeMixin,
    ActividadCiudadanoEstadoMixin
  ],
}
</script>

<style lang="scss">
.pp-el-descriptions-item {
  padding: 22px 10px !important;
}
</style>
